/**
 * "Lieber telefonisch?" line (prototype `.h-callline`). Renders only when the
 * caller has real contact data; the opening-hours payload carries none today,
 * so nothing is hardcoded here.
 */
import { FC } from "react"
import { TextStyle, View, ViewStyle } from "react-native"
import Icon from "react-native-vector-icons/MaterialIcons"

import { Text } from "@/components/Text"

import { font, tokens } from "./tokens"

export interface CallLineProps {
  phone?: string | null
  /** e.g. "Mo-Fr 9-17 Uhr" */
  hours?: string | null
}

export const CallLine: FC<CallLineProps> = ({ phone, hours }) => {
  if (!phone) return null
  return (
    <View style={$line} testID="call-line">
      <Icon name="phone" size={20} color={tokens.red} />
      <Text style={$text}>
        Lieber telefonisch? <Text style={$bold}>{phone}</Text>
        {hours ? ` · ${hours}` : ""}
      </Text>
    </View>
  )
}

const $line: ViewStyle = {
  flexDirection: "row",
  alignItems: "center",
  gap: 10,
  paddingVertical: 10,
  paddingHorizontal: 12,
  borderRadius: 12,
  backgroundColor: tokens.mist,
}
const $text: TextStyle = {
  flex: 1,
  fontSize: 14,
  lineHeight: 19,
  fontFamily: font.regular,
  color: tokens.ink,
}
const $bold: TextStyle = { fontFamily: font.bold }
